import {
  createPermissionGuard,
  type PermissionGuardBaseProps,
} from '@gokrew/ui';
import type { PermissionScope } from '@/types/permissions';
import { usePermissions } from '@/context/PermissionContext';

export type PermissionGuardProps = Omit<
  PermissionGuardBaseProps<PermissionScope, Set<Partial<PermissionScope>>>,
  'permissions'
>;

export const PermissionGuard = createPermissionGuard<
  PermissionScope,
  Set<Partial<PermissionScope>>
>(usePermissions);
